/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import './AuthFormContainer.scss';

const AuthFormContainer = ({children, className = '', ...props}) => (
  <div className={`auth-form-container ${className}`} {...props}>{children}</div>
);

const { node, string } = PropTypes;

AuthFormContainer.propTypes = {
  children: node.isRequired,
  className: string,
};

export default AuthFormContainer;
